import { Injectable } from '@angular/core';
import { IAnalyticsService, EventProperties, UserProperties } from './analytics.interface';

declare global {
  interface Window {
    dataLayer?: any[];
    gtag?: (...args: any[]) => void;
  }
}

@Injectable({
  providedIn: 'root'
})
export class GtmAnalyticsService implements IAnalyticsService {
  private dataLayer: any[] = [];
  private gtag: any;

  constructor() {
    this.init();
  }

  init(): void {
    if (typeof window !== 'undefined') {
      // GTM is already loaded in index.html, just get the reference
      window.dataLayer = window.dataLayer || [];
      this.dataLayer = window.dataLayer;

      // Setup gtag function if not exists
      if (!window.gtag) {
        window.gtag = function() {
          window.dataLayer!.push(arguments);
        };
      }
      this.gtag = window.gtag;

      console.log('GTM analytics service connected (GTM ID: GTM-5KCJPZBK)');
    }
  }

  trackEvent(eventName: string, properties?: EventProperties): void {
    if (this.dataLayer) {
      this.dataLayer.push({
        event: eventName,
        ...properties
      });
    } else {
      console.warn(`GTM not initialized. Event not tracked: ${eventName}`);
    }
  }

  trackPageView(pageName: string, properties?: EventProperties): void {
    if (this.dataLayer) {
      this.dataLayer.push({
        event: 'page_view',
        page_path: pageName,
        page_title: properties?.['title'] || pageName,
        ...properties
      });
    } else {
      console.warn(`GTM not initialized. Page view not tracked: ${pageName}`);
    }
  }

  identify(userId: string, properties?: UserProperties): void {
    if (this.dataLayer) {
      this.dataLayer.push({
        event: 'identify',
        userId: userId,
        userProperties: properties
      });
    } else {
      console.warn(`GTM not initialized. User not identified: ${userId}`);
    }
  }

  setUserProperties(properties: UserProperties): void {
    if (this.dataLayer) {
      this.dataLayer.push({
        event: 'set_user_properties',
        userProperties: properties
      });
    } else {
      console.warn('GTM not initialized. User properties not set');
    }
  }

  reset(): void {
    if (this.dataLayer) {
      // Clear user-related data from dataLayer
      this.dataLayer.push({
        event: 'reset_user',
        userId: null,
        userProperties: null
      });
    } else {
      console.warn('GTM not initialized. Cannot reset');
    }
  }
}